var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilledStarinline = function SvgFilledStarinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21201F",
    d: "M10.584 12.88a.1.1 0 0 0 .149-.109L9.71 8.374a.1.1 0 0 1 .032-.098l3.412-2.957a.1.1 0 0 0-.056-.175l-4.499-.386a.1.1 0 0 1-.083-.06L6.759.551a.1.1 0 0 0-.184 0L4.818 4.698a.1.1 0 0 1-.084.06l-4.498.386a.1.1 0 0 0-.057.175L3.59 8.276a.1.1 0 0 1 .032.098L2.6 12.771a.1.1 0 0 0 .15.108l3.865-2.331a.1.1 0 0 1 .103 0z"
  })));
};
export default SvgFilledStarinline;